module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "outpfm1"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x-2-chapter-title",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Preface"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Our quartet—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("100 Oklahoma Outlaws, Lawmen, and Gangsters; 200 Texas Outlaws and Lawmen; Ten Deadly Texans;")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arizona Gunfighters")]), _vm._v(" coauthored by Dan Anderson—focused on the emergence of law and order in Oklahoma, Texas, eastern New Mexico, and Arizona. And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old West Swindlers")]), _vm._v(" examined fraud, graft, and corruption on the American frontier.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Outlaws with Badges")]), _vm._v(" was prompted by a single question posed in many ways during interviews, speeches, and book signings over the past six years. No, most Old West lawmen weren’t criminals, but these pages present some former outlaws turned good, former lawmen gone bad, and some of the lawmen who moonlighted as robbers and rustlers. And we couldn’t include all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("We have made every effort to provide the most accurate, historically accepted version of events, while providing credible, alternative versions or interpretations either in the text or footnotes. Names and places are spelled in accordance with common modern usage, with alternatives found in primary sources placed in parentheses or referenced in footnotes. Every effort has been made to reference the generally accepted dates of events described here, with alternatives referenced or footnoted as appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Robert Barr Smith ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tough Towns, Outlaw Tales of Oklahoma")]), _vm._v("), who previously guided our efforts as a consulting editor, contributed the prologue and first eight chapters of this work"), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v(".")]), _vm._v(" Judgments made concerning the relative credibility of competing sources, dates, and any errors sifting fact from mythology have been our own.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13da5495","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/preface.vue
// module id = 72
// module chunks = 0